import gql from 'graphql-tag';
import manualMailFragment from '../manualMail';

export default gql`
  fragment manualMailOpenProspectActivityFragment on ManualMailOpenProspectActivity {
    id
    manualMail {
      ...manualMailFragment
      action {
        step {
          name
        }
      }
    }
  }
  ${manualMailFragment}
`;
